
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';

interface JobAdvertisementProps {
  companyName: string;
}

const JobAdvertisements: React.FC<JobAdvertisementProps> = ({ companyName }) => {
  // This would typically come from an API or database
  const jobs = [
    {
      id: 1,
      title: 'Senior Software Engineer',
      location: 'Remote',
      type: 'Full-time',
      link: '#'
    },
    {
      id: 2,
      title: 'Marketing Manager',
      location: 'Sydney, Australia',
      type: 'Full-time',
      link: '#'
    },
    {
      id: 3,
      title: 'Customer Support Specialist',
      location: 'Melbourne, Australia',
      type: 'Contract',
      link: '#'
    }
  ];

  return (
    <Card className="mb-8 border border-redflags-light/70 bg-[#F2FCE2]">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium text-redflags-dark">Job Opportunities at {companyName} - Powered by GreenFlags</CardTitle>
        <CardDescription>Current openings that might interest you</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
          {jobs.map(job => (
            <div key={job.id} className="border rounded-md p-4 hover:shadow-md transition-shadow bg-white">
              <h3 className="font-medium text-redflags-dark mb-1">{job.title}</h3>
              <div className="text-sm text-gray-500 mb-3">
                <div>{job.location}</div>
                <div>{job.type}</div>
              </div>
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full text-redflags-red border-redflags-red/50 hover:bg-redflags-light/20"
                asChild
              >
                <a href={job.link} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-1">
                  View Job <ExternalLink className="h-3 w-3" />
                </a>
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default JobAdvertisements;
